'use client';
class DesignSystemError extends Error {
    constructor(pack, message, info){
        const _info = info ? `\n ${JSON.stringify(info, null, 2)}` : '';
        super(`[@s7/${pack}]: ${message}${_info}`);
        this.info = info;
        Object.setPrototypeOf(this, DesignSystemError.prototype);
    }
}

export { DesignSystemError };
//# sourceMappingURL=DesignSystemError.js.map
